namespace GeniuzPOS.QRreport {
    export interface QMonthForm {
        Month: Serenity.IntegerEditor;
        MonthName: Serenity.StringEditor;
        MonthNameEn: Serenity.StringEditor;
        Months: Serenity.StringEditor;
    }

    export class QMonthForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QMonth';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QMonthForm.init)  {
                QMonthForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(QMonthForm, [
                    'Month', w0,
                    'MonthName', w1,
                    'MonthNameEn', w1,
                    'Months', w1
                ]);
            }
        }
    }
}
